import type { AssetTab, MaterialLibraryEntry } from './types'

export type AudioMaterialCategory = 'all' | 'narration' | 'bgm'

export interface MaterialSectionCopy {
  label: string
  title: string
  description: string
  searchPlaceholder: string
  refreshLabel: string
  emptyDescription: string
}

export const AUDIO_MATERIAL_CATEGORY_OPTIONS: Array<{ label: string; value: AudioMaterialCategory }> = [
  { label: '全部音频', value: 'all' },
  { label: '旁白素材', value: 'narration' },
  { label: 'BGM 素材', value: 'bgm' },
]

export function getMaterialSectionCopy(activeTab: AssetTab): MaterialSectionCopy {
  if (activeTab === 'video') {
    return {
      label: '视频素材',
      title: '本地上传和 AI 生成视频都在这里',
      description: '你在工作台里 AI 生成或人工上传的视频，会自动归档到这里，方便回看、复用和统一管理。',
      searchPlaceholder: '搜索视频名称、项目名或说明',
      refreshLabel: '视频',
      emptyDescription: '还没有找到视频素材。你在工作台里 AI 生成或上传的视频，刷新后会出现在这里。',
    }
  }

  if (activeTab === 'audio') {
    return {
      label: '音频素材',
      title: '旁白和 BGM 素材分层归档在这里',
      description: '终版音频工作台里生成的旁白、上传过的 BGM，以及后续沉淀下来的可复用音频都会集中在这里，先选素材再进混音预览。',
      searchPlaceholder: '搜索音频名称、项目名或说明',
      refreshLabel: '音频',
      emptyDescription: '还没有找到音频素材。你在终版音频工作台里生成或上传的音频，刷新后会出现在这里。',
    }
  }

  return {
    label: '图片素材',
    title: '本地上传和项目图片都在这里',
    description: '你在工作台里本地上传的图片会自动出现在这里。给分镜选图时，优先从这里挑，不用再回忆传到哪了。',
    searchPlaceholder: '搜索图片名称、项目名或说明',
    refreshLabel: '图片',
    emptyDescription: '还没有找到图片素材。你在工作台里上传的图片，刷新后会出现在这里。',
  }
}

export function getAudioMaterialCategory(entry: MaterialLibraryEntry): AudioMaterialCategory {
  if (entry.material_type === 'music_file') {
    return 'bgm'
  }
  if (entry.material_type === 'audio_file') {
    return 'narration'
  }
  return 'all'
}

export function filterAudioMaterialEntries(entries: MaterialLibraryEntry[], category: AudioMaterialCategory): MaterialLibraryEntry[] {
  if (category === 'all') {
    return entries
  }

  return entries.filter((entry) => getAudioMaterialCategory(entry) === category)
}
